import * as fromDatatype from '../datatype-library/index';

export interface app_auth_passwordless_login_with_authentication_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  login_method: fromDatatype.VarcharDatatypeInterface;
  login_key: fromDatatype.VarcharDatatypeInterface;
  subject_guid: fromDatatype.GuidDataFieldInterface;
  verification_code: fromDatatype.VarcharDatatypeInterface;
  verification_status: fromDatatype.VarcharDatatypeInterface;
  principal_id: fromDatatype.VarcharDatatypeInterface;
  website_hdr_guid: fromDatatype.GuidDataFieldInterface;
  tenant_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  valid_date_end: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
}

export class app_auth_passwordless_login_with_authentication_RowClass
  implements app_auth_passwordless_login_with_authentication_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  login_method: fromDatatype.VarcharDatatypeInterface;
  login_key: fromDatatype.VarcharDatatypeInterface;
  subject_guid: fromDatatype.GuidDataFieldInterface;
  verification_code: fromDatatype.VarcharDatatypeInterface;
  verification_status: fromDatatype.VarcharDatatypeInterface;
  principal_id: fromDatatype.VarcharDatatypeInterface;
  website_hdr_guid: fromDatatype.GuidDataFieldInterface;
  tenant_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  valid_date_end: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
}
